import { Component, OnInit, Input } from '@angular/core';
import { LocalizedProcess, ProcessStage, KnownProcessType } from '../../../models/process-models';
import { EnumDescription } from '../../../helpers/enum-description.helper';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss']
})
export class ProcessComponent implements OnInit {

  @Input()
  process: LocalizedProcess;

  isLimitlength: number = 84;

  isCollapsed: boolean = true;
  appraisedUsersStringLength: number;
  processStage = ProcessStage;
  isProcess = false;
  
  constructor() { }

  ngOnInit() {
    this.appraisedUsersStringLength = this.process.appraisedPersons
      .map(p => p.name.length + 3).reduce((a, b) => a + b, 0);
  }

  showCollapse(): boolean {
    return this.appraisedUsersStringLength >= this.isLimitlength;
  }

  getProcessSelectionTypes(): string {
    return this.process.knownProcessTypes
      .map(k => EnumDescription.GetDescription(KnownProcessType, k as number)).join(', ');
  }
}
